export default __webpack_public_path__ + "static/media/youtubeDeskFill.5b48478b.svg";